import { getPdpAdsParams } from '../url';

export const getNewSourceForAddToCart = ({ product, trackDataInDialog }: { product: any; trackDataInDialog: any }) => {
  const pageData = window._weeeTracker?.pageContext.getPageContext();
  const refererPageCtxApp = window._weeeTracker?.getRefererPageCtxApp();
  const currentPageCtxApp = window._weeeTracker?.getCurrentPageCtxApp();
  //如果是分类页面的加购，需要添加 filter_sub_category 字段
  let filterSubCategory = undefined;
  if (window.location.pathname.includes('/category/')) {
    const categoryURL = new URL(window.location.href);
    filterSubCategory = categoryURL.searchParams.get('filter_sub_category');
    if (!filterSubCategory) {
      filterSubCategory = categoryURL.pathname.split('/').pop();
    }
  }
  // Fix: product.extra_attrs might be a JSON string, causing spread operator to create indexed chars {0: '{', 1: '"'...}
  let extraAttrs = product?.extra_attrs || {};
  try {
    if (typeof extraAttrs === 'string') {
      extraAttrs = JSON.parse(extraAttrs);
    }
  } catch (error) {
    console.error('Error parsing extra_attrs:', error);
    extraAttrs = {};
  }
  // 将 refererPageCtxApp 中的 _p_ 和 rest 中的 key 加上 referer_ 前缀
  const { _p_, ...rest } = refererPageCtxApp || {};
  const addRefCtxPrefix =
    Object.keys(rest).length > 0
      ? Object.fromEntries(Object.entries(rest).map(([key, value]) => [`referer_${key}`, value]))
      : {};
  // 解析 product link：若当前页 pathname 与 link 的 pathname 相同，则不把 link 上的 query 写入 newSource
  const productLink = product?.link ?? '';
  const getPathnameFromLink = (link: string): string => {
    if (!link || typeof link !== 'string') return '';
    if (link.startsWith('http://') || link.startsWith('https://')) {
      try {
        return new URL(link).pathname;
      } catch {
        return link.split('?')[0] || '';
      }
    }
    return (link.split('?')[0] || link).trim();
  };
  const currentPathname = window.location.pathname;
  const productLinkPathname = getPathnameFromLink(productLink);
  const isSamePathname = currentPathname === productLinkPathname;

  const addSkuPrefix: Record<string, string> = {};
  if (!isSamePathname) {
    const productLinkParams = getPdpAdsParams(product);
    Object.entries(productLinkParams).forEach(([key, value]) => {
      const strValue = typeof value === 'string' ? value : String(value ?? '');
      if (key.startsWith('utm_')) {
        addSkuPrefix[`sku_${key}`] = strValue;
      } else {
        addSkuPrefix[key] = strValue;
      }
    });
  }

  const newSource = {
    ...(_p_ || {}),
    ...addRefCtxPrefix,
    ...addSkuPrefix,
    ...(currentPageCtxApp || {}),
    ...(product?.positionInfoT2?.modSecPos || {}),
    ...extraAttrs,
    filter_sub_category: filterSubCategory,
    prod_pos: product?.positionInfoT2?.prodPos ?? null,
    page_key: (!!trackDataInDialog?.page_key ? trackDataInDialog?.page_key : pageData?.page_key) || null,
    referer_page_key:
      (!!trackDataInDialog?.referer_page_key ? trackDataInDialog?.referer_page_key : pageData?.referer_page_key) ||
      null,
    view_id: (!!trackDataInDialog?.view_id ? trackDataInDialog?.view_id : pageData?.view_id) || null,
    referer_view_id:
      (!!trackDataInDialog?.referer_view_id ? trackDataInDialog?.referer_view_id : pageData?.referer_view_id) || null
  };
  return JSON.stringify(newSource);
};
